import React, { useState } from "react";
import { CloseIcon, CloseIconBig } from "../../../assets/icons";
import { useNavigate } from "react-router-dom";
import SubscriptionPage from "../../../pages/Subscription";
import UpgradeIcon from "../../../assets/icons/Upgrade"

interface MobileSubscriptionModalProps {
  onClose: () => void;
  titleText: string; 
  subtitleText: string;
  subtitleText2?: string;
}

const MobileSubscriptionModal: React.FC<MobileSubscriptionModalProps> = ({
  onClose,
  titleText,
  subtitleText,
  subtitleText2,
}) => {
  const navigate = useNavigate();
   const [showModal, setShowModal] = useState(false); // State to control modal visibility

  const handleUpgradePlan = () => {
    navigate("/subscription");
    onClose();
  };

  return (
    <>
      <div className="max-w-[390px] text-[#212121] pl-[16px] pr-[12px] bg-white rounded-[8px] py-[16px] shadow-xl">
        <div className="flex items-center justify-end">
          <button onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        <div className="flex flex-col justify-center items-center gap-2">
        <div><UpgradeIcon/></div>
        {/* <p>{titleText}</p> */}
        <p className="text-xl font-semibold"> Unlock Esemie’s Full Access</p>
        <p className="text-center">Get access to advanced features you need to enhance your workflow</p>
        </div>

        {/* <p className="text-[12px] font-medium">
          {subtitleText} <br /> {subtitleText2}{" "}
        </p> */}
        <button
          className="py-3 w-full text-[#ffffff] text-[14px] font-semibold mt-4 bg-[#044E97] rounded-[4px] text-center"
          onClick={() => setShowModal(true)}
        >
          Upgrade Plan
        </button>
      </div>

          {/* Render the SubscriptionModal */}
          {showModal && (
        <SubscriptionPage
          close={() => setShowModal(false)} // Close modal
        />
      )}
    </>
  );
};

export { MobileSubscriptionModal };
